<script lang="ts">
  import { lang, setLang, t } from '../i18n';
</script>

<button
  type="button"
  class="lang"
  lang={$lang === 'en' ? 'de' : 'en'}
  aria-label={$t('lang.switchToLabel')}
  onclick={() => setLang($lang === 'en' ? 'de' : 'en')}
>
  {$lang === 'en' ? 'DE' : 'EN'}
</button>

<style>
  .lang {
    min-width: var(--bar-h);
    padding: 0 10px;
    border-left: var(--rule-w) solid var(--rule);
    font-weight: 600;
    letter-spacing: var(--track-caps);
    transition: color var(--dur-fast) var(--ease);
  }
  .lang:hover {
    color: var(--accent);
  }
  /* on phones the header is full: the language moves into the settings sheet (S2-16) */
  @media (max-width: 480px) {
    .lang {
      display: none;
    }
  }
</style>
